// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles-m__spinner---27Bu9"};